import { SettingsNavButton } from "@/components/settings/settings-nav-button";
import { SettingsSectionLabel } from "@/components/settings/settings-section-label";
import { memo } from "react";
import DietaryRequirementPage from "../dietary-requirement";
import FavoriteCuisinesPage from "../favorite-cuisines";
import FoodAvoidsPage from "../food-avoids";
import { SettingModalHeader } from "../../components/setting-modal-header";

interface PreferencesPageProps {
  onBack?: () => void;
}

const PreferencesPage = memo(function PreferencesPage({ onBack }: PreferencesPageProps) {
  return (
    <div className="h-full w-full bg-[#fcfbfb]">
      <SettingModalHeader title="Food Preferences" onBack={onBack} />

      <div className="px-9 pt-4 pb-20">
        <div className="flex flex-col gap-2">
          <SettingsSectionLabel label="Dislikes & Cuisines" />
          <div className="flex flex-col gap-4">
            <SettingsNavButton label="Foods You Don't Like">
              {(onClose) => <FoodAvoidsPage onBack={onClose} isModal />}
            </SettingsNavButton>

            <SettingsNavButton label="Favourite Cuisines">
              {(onClose) => <FavoriteCuisinesPage onBack={onClose} isModal />}
            </SettingsNavButton>

            <div className="flex flex-col gap-2">
              <SettingsSectionLabel label="Dietary Requirements" />
              <SettingsNavButton label="Lifestyle, Milk, Allergens">
                {(onClose) => <DietaryRequirementPage onBack={onClose} isModal />}
              </SettingsNavButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default PreferencesPage;
